import React from 'react';

interface SVGProps {
  title?: string;
  titleId?: string;
  className: string;
}

const IconVerifyBoostSVG = ({
  title,
  titleId,
  ...props
}: SVGProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={128}
    height={128}
    viewBox="0 0 128 128"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#F8B1DC"
        d="M93.54 88.57H53.57c-8.73 0-15.8 7.07-15.8 15.8 0 8.72 7.07 15.8 15.8 15.8h39.97c8.73 0 15.8-7.07 15.8-15.8s-7.07-15.8-15.8-15.8Z"
      />
      <path
        fill="#EAAB7D"
        d="M51.52 110.874s-.03-.02-.04-.03v.15s0-.08.04-.12Z"
      />
      <path
        fill="#F470BD"
        d="M32.5 47.46c1.29-.05 3.1 0 4.52.49.3.11.57.26.8.46-.11-.78.02-1.61.41-2.19.23-.36.77-1.09 1.27-1.76.38-.52.64-1.12.77-1.75-3.35.79-6.37 2.38-8.87 4.58.36.12.73.21 1.11.19l-.01-.02Z"
      />
      <path
        fill="#F470BD"
        d="m114.05 57.03-9.47-5.29a4.067 4.067 0 0 1-1.93-2.47c-.09-.35-.14-.71-.14-1.07v-4.32a20.599 20.599 0 0 0-8.28-1.74H46.2c-.03 1.17-.17 2.32-.51 3.3-.56 1.64-2.86 3.82-5.15 5.06-.74.4-1.36.25-1.83-.18 0 .78-.42 1.53-1.3 1.85-3.98 1.48-4.54 2.22-7.22 1.84-.99-.14-2.31-.2-3.71-.31a20.496 20.496 0 0 0-2.13 9.08c0 11.4 9.25 20.65 20.65 20.65h49.24c11.4 0 20.65-9.25 20.65-20.65 0-2-.3-3.92-.83-5.74l-.01-.01Z"
      />
      <path
        fill="#fff"
        d="M114.08 28.812h-.02c.05-.02.11-.04.17-.07-.05.02-.1.04-.15.07ZM102.65 49.273Z"
      />
      <path
        fill="#AF6E37"
        d="M31.39 47.27c-.65-.23-1.23-.65-1.61-1.26-.59-.95-1.17-2.18-1.06-3.18.3-2.82 2.6-4.81 4.16-5.41 2-.76 3.56-1.1 5.87.6.92.67 1.33 1.85 1.54 2.93.11.58.09 1.17-.02 1.73 1.52-.36 3.1-.57 4.73-.57h1.2c.06-2.89-.62-5.88-1.04-6.69-.95-1.85-2.45-2.9-5.82-4.35-.16-.07-.35-.14-.57-.21.45-.47 1.02-1.05 1.45-1.38 2.42-1.86 2.79-1.93 5.44-3.13 3.2-1.43 7.96-1.21 9.95-2.52 3-1.99.7-6.37-3.23-6.25-2.24.07-7.27 1-10.5 2.5-3.24 1.51-5.97 3.13-7.09 3.93-.45.32-1.59 1-1.59 1s.6-.95.98-1.47c.76-1.04 3.08-2.86 5.37-4.18 2.36-1.35 5.24-1.91 7.24-3.23 3.44-2.27 1.09-6.67-2.92-5.72-2.51.59-6.01 1.99-8.71 3.49-3.44 1.92-6.06 4.26-6.68 4.72-.2.15-1.22 1.33-1.33 1.24-.11-.09.32-1.45 1.11-2.41 1.38-1.7.57-.84 2.65-2.68 1.56-1.37 3.27-1.97 3.84-2.76 2.33-3.23-.73-6.06-3.88-4.67-.45.19-2.13 1.08-5.18 3.66-3.05 2.59-4.99 4.89-6.28 6.32-4.33 4.83-7.64 9.05-8.42 10.37-1.51 2.56-2.36 4.89-2.3 7.16l-7.57 5.04C-.92 41.37-.09 46.27 3 50.92l-.02.02c3.1 4.68 7.32 7.35 9.46 6l.05-.03 7.24-4.81c1.71 1.07 4.35 1.39 6.74 1.57 1.21-2.46 2.88-4.64 4.92-6.43v.03Z"
      />
      <path
        fill="#F470BD"
        d="M37.4 52.17c.88-.32 1.29-1.07 1.3-1.85.47.43 1.09.57 1.83.18 2.29-1.24 4.6-3.42 5.15-5.06.34-.99.48-2.14.51-3.3h-1.2c-1.63 0-3.21.21-4.73.57a4.37 4.37 0 0 1-.77 1.75c-.5.67-1.03 1.4-1.27 1.76-.39.58-.52 1.41-.41 2.19-.22-.19-.5-.35-.8-.46-1.42-.5-3.23-.54-4.52-.49-.39.02-.76-.06-1.11-.19a20.691 20.691 0 0 0-4.92 6.43c1.4.11 2.72.17 3.71.31 2.68.38 3.24-.36 7.22-1.84h.01Z"
      />
      <path
        fill="#fff"
        d="M94.43 57.32H72.46v2.44h21.97v-2.44ZM94.43 65.797H72.46v2.44h21.97v-2.44ZM94.43 98.61H72.46v2.439h21.97v-2.44ZM94.43 107.086H72.46v2.44h21.97v-2.44Z"
      />
      <path
        fill="#503DC9"
        d="M105.05 40.648v7.62c0 .45.22.85.58 1.1.04.03.08.07.12.09l9.64 5.39c.2.11.43.17.66.17.23 0 .46-.06.66-.17l9.64-5.39c.44-.25.7-.7.7-1.19v-10.69c0-.5-.27-.95-.7-1.19l-9.64-5.39c-.2-.11-.43-.17-.66-.17h-.08c-.2.01-.39.06-.58.16l-2.51 1.4-4.74 2.65-2.4 1.34c-.12.07-.22.16-.32.26-.19.19-.3.45-.35.71-.01.08-.03.16-.03.23v3.06l.01.01Z"
      />
      <path
        fill="#fff"
        d="M114.86 46.565c-.32 0-.63-.13-.85-.35l-3.26-3.28 1.7-1.71 2.41 2.42 4.81-4.84 1.7 1.71-5.67 5.7c-.22.23-.53.35-.85.35h.01Z"
      />
      <g clipPath="url(#b)">
        <path
          fill="#A05F45"
          d="M51.934 104.355a1.197 1.197 0 1 0 0-2.394 1.197 1.197 0 0 0 0 2.394Zm.144-1.769c.243 0 .446.198.446.446a.444.444 0 0 1-.446.445.444.444 0 0 1-.445-.445c0-.248.198-.446.445-.446Z"
        />
        <path
          fill="#A05F45"
          d="M60.808 102.336a1.703 1.703 0 0 0-.346-.036c-.077 0-.144.013-.216.022-.01.05-.027.09-.077.113l-.018.009-.297 1.085-.04-.919-1.238.612a1.5 1.5 0 0 1-1.494 1.44 1.515 1.515 0 0 1-1.498-1.498c0-.824.675-1.499 1.498-1.499.738 0 1.346.536 1.472 1.233l1.246-.616-.103-2.421c-.203.085-.423.13-.657.13-.783 0-1.44-.522-1.643-1.237a2.821 2.821 0 0 1-3.55-1.58 3.025 3.025 0 0 1-.19-.611 2.228 2.228 0 0 1-1.44 1.242 3.481 3.481 0 0 1-.679.125c.01.068.023.135.023.203a1.486 1.486 0 0 1-2.061 1.368l-.081 2.875 1.035.554a1.5 1.5 0 0 1 1.476-1.273 1.5 1.5 0 0 1 1.498 1.498c0 .824-.675 1.498-1.498 1.498-.824 0-1.44-.621-1.49-1.404-.013 0-.027 0-.04-.009l-.99-.531-.023.797-.301-.968-.203-.108c-.05-.027-.067-.081-.067-.135h-.027c-.09 0-.18.014-.27.027-.801.135-1.418.851-1.418 1.724 0 .968.756 1.75 1.683 1.75.09 0 .176-.013.261-.027.117 2.165.945 4.068 2.187 5.315l.059 3.424c.022.86 1.57 1.548 3.474 1.544 1.894 0 3.438-.693 3.47-1.544l.062-3.64c1.12-1.242 1.863-3.051 1.976-5.09.058.005.117.018.18.018.931 0 1.683-.782 1.683-1.75 0-.846-.576-1.548-1.341-1.714l.013.004Zm-5.071-2.214.166-.441a.15.15 0 0 1 .194-.085l2.367.899a.15.15 0 0 1 .085.194l-.166.441a.148.148 0 0 1-.194.085l-2.367-.9a.149.149 0 0 1-.085-.193Zm-2.498.198-2.367.9a.148.148 0 0 1-.193-.086l-.167-.441a.147.147 0 0 1 .086-.193l2.367-.9a.148.148 0 0 1 .193.086l.167.44a.148.148 0 0 1-.086.194Zm-.14 5.004 1.59-2.511-.019 3.613-1.48-.751a.18.18 0 0 1-.077-.063.246.246 0 0 1-.013-.288Zm1.432 6.975c-.108.009-.22.018-.329.018-1.174 0-2.335-.585-2.875-.963a.152.152 0 0 1-.036-.212.153.153 0 0 1 .211-.036c.554.387 1.81 1.013 3.002.891.08-.004.157.054.166.135a.155.155 0 0 1-.135.167h-.004Zm1.674-4.365c-.585.729-1.238.918-1.75.918-.514 0-.896-.194-.905-.194-.072-.04-.104-.13-.063-.202a.145.145 0 0 1 .202-.063c.05.027 1.26.634 2.277-.644a.147.147 0 0 1 .212-.022.146.146 0 0 1 .022.211l.005-.004Z"
        />
        <path
          fill="#A05F45"
          d="M57.091 101.961a1.196 1.196 0 1 0-.002 2.392 1.196 1.196 0 0 0 .002-2.392Zm-.099 1.512a.447.447 0 0 1-.445-.446c0-.247.198-.445.445-.445.248 0 .446.198.446.445a.444.444 0 0 1-.446.446Z"
        />
        <path
          fill="#2F2725"
          d="M52.078 103.477a.447.447 0 0 0 .446-.446.444.444 0 0 0-.446-.445.444.444 0 0 0-.445.445c0 .248.198.446.445.446ZM56.992 102.586a.446.446 0 1 0 .002.893.446.446 0 0 0-.002-.893Z"
        />
        <path
          fill="#883E28"
          d="M53.117 105.611c.023.027.05.05.077.063l1.48.752.019-3.614-1.589 2.511a.242.242 0 0 0-.036.095c-.005.036 0 .067.005.103a.33.33 0 0 0 .044.09Z"
        />
        <path
          fill="#2F2725"
          d="M53.158 99.69a.15.15 0 0 0-.194-.085l-2.367.899a.15.15 0 0 0-.085.194l.166.441a.15.15 0 0 0 .194.085l2.367-.9a.149.149 0 0 0 .086-.193l-.167-.441ZM55.822 100.324l2.367.9a.148.148 0 0 0 .194-.085l.166-.441a.148.148 0 0 0-.085-.194l-2.367-.9a.148.148 0 0 0-.194.086l-.166.441a.147.147 0 0 0 .085.193ZM55.97 107.746c-1.021 1.274-2.227.666-2.276.644a.147.147 0 0 0-.203.063.148.148 0 0 0 .063.202c.009 0 .383.194.904.194.523 0 1.166-.185 1.751-.918a.15.15 0 0 0-.023-.212.155.155 0 0 0-.211.023l-.005.004ZM49.392 103.514l.022-.796-.324-.171.302.967ZM59.858 103.53l.298-1.085-.334.167.036.918Z"
        />
        <path
          fill="#2F2725"
          d="M49.504 99.502a1.486 1.486 0 0 0 2.061-1.368c0-.067-.009-.135-.022-.202.202-.014.427-.054.68-.126a2.218 2.218 0 0 0 1.44-1.242c.035.216.103.414.188.612a2.821 2.821 0 0 0 3.55 1.58 1.712 1.712 0 0 0 2.3 1.106l.104 2.421.234-.112c.04-.023.085-.018.126 0 .022.009.04.027.058.045.01.009.014.018.023.027.013.027.009.058.004.09.072-.009.144-.023.216-.023.117 0 .234.014.347.036.27-.697.423-1.444.423-2.232 0-.274-.014-.535-.027-.787.121-.387.193-.801.216-1.224a3.47 3.47 0 0 0 .009-.212v-.08c0-.073-.005-.14-.01-.212-.12-2.552-2.15-4.581-4.639-4.581-.463 0-.913.072-1.336.202a2.685 2.685 0 0 0-4.707 1.004c-.85.135-1.647.733-2.039 1.647a2.822 2.822 0 0 0-.135 1.872 6.434 6.434 0 0 0-.459 2.376c0 .783.153 1.53.423 2.223a1.71 1.71 0 0 1 .27-.027h.027c0-.023-.004-.05.01-.072.03-.054.085-.072.143-.068.023 0 .04 0 .059.005l.144.076.247.135.081-2.875"
        />
        <path
          fill="#fff"
          d="M51.934 101.656a1.5 1.5 0 0 0-1.476 1.274l-1.035-.554-.247-.135-.144-.076s-.04 0-.059-.005c-.058-.004-.117.014-.144.068-.013.022-.009.049-.009.072 0 .054.018.103.068.135l.202.108.324.171.99.531s.027.009.04.009c.05.783.698 1.404 1.49 1.404s1.499-.675 1.499-1.499c0-.823-.675-1.498-1.499-1.498v-.005Zm0 2.7a1.196 1.196 0 1 1-.002-2.392 1.196 1.196 0 0 1 .002 2.392ZM60.241 102.232s-.014-.018-.023-.027a.154.154 0 0 0-.184-.045l-.234.113-1.246.616a1.498 1.498 0 1 0-1.472 1.764c.824 0 1.462-.639 1.494-1.44l1.237-.612.334-.166.017-.009c.045-.023.068-.068.077-.113 0-.031.009-.058-.005-.09l.005.009Zm-3.15 2.124a1.196 1.196 0 1 1-.002-2.392 1.196 1.196 0 0 1 .002 2.392Z"
        />
        <path
          fill="#883E28"
          d="M54.499 111.997c-1.193.117-2.448-.504-3.002-.891a.153.153 0 0 0-.211.036.152.152 0 0 0 .036.212c.535.378 1.701.963 2.875.963.113 0 .221-.005.329-.018a.149.149 0 0 0 .135-.167.152.152 0 0 0-.166-.135h.004Z"
        />
      </g>
      <g clipPath="url(#c)">
        <path
          fill="#FFD269"
          d="M65.816 66.243c-1.005-.665-1.011-2.112-.986-2.592a8.563 8.563 0 0 0-3.398-7.808.68.68 0 0 0-.122-.102c-.038-.026-.083-.058-.128-.083-.057-.039-.121-.084-.179-.122-1.05-.723-2.368-1.971-2.963-3.75a5.682 5.682 0 0 0-10.003-1.07 5.267 5.267 0 0 0-2.861-.844A5.276 5.276 0 0 0 40.28 53.2c-.55 1.651-1.773 2.803-2.746 3.475-.057.039-.108.07-.166.11-.038.025-.083.057-.115.076a.456.456 0 0 0-.115.096 7.939 7.939 0 0 0-3.162 5.638s0 1.837-1.869 3.655l-.032.032v.006a4.843 4.843 0 0 0-1.389 3.398 4.873 4.873 0 0 0 4.87 4.87 4.795 4.795 0 0 0 2.209-.537c.057-.032.121-.064.179-.096 1.67-.85 2.413-.537 3.86.55v-.012a7.803 7.803 0 0 0 4.569 1.472 7.88 7.88 0 0 0 3.315-.736 8.495 8.495 0 0 0 3.942.973 8.529 8.529 0 0 0 2.874-.506v.013c.045-.02.096-.045.147-.064a8.921 8.921 0 0 0 1.74-.89c.974-.499 1.94-.825 4.167-.601.333.083.672.128 1.03.128a4.316 4.316 0 0 0 4.314-4.314 4.301 4.301 0 0 0-2.073-3.68l-.013-.013Z"
        />
        <path
          fill="#FFD269"
          d="M55.252 64.31c2.693-1.308 3.657-4.876 2.155-7.97-1.503-3.093-4.904-4.54-7.597-3.232-2.693 1.308-3.658 4.876-2.155 7.97 1.503 3.093 4.904 4.54 7.597 3.232Z"
        />
        <path
          fill="#F4BAAF"
          d="M49.91 72.702c4.901-.425 8.602-3.91 8.266-7.784-.336-3.873-4.582-6.668-9.484-6.243-4.902.425-8.603 3.91-8.267 7.784.336 3.873 4.582 6.669 9.484 6.243Z"
        />
        <path
          fill="#FFD269"
          d="M55.237 56.544c-2.554-1.165-4.98-1.46-6.17-.742-1.19-.71-3.616-.423-6.17.742-3.155 1.44-5.17 3.808-4.492 5.28.672 1.472 3.084 1.331 6.24-.109 1.862-.85 3.513-2.01 4.422-3.123.909 1.114 2.56 2.272 4.422 3.123 3.156 1.44 5.568 1.587 6.24.11.672-1.473-1.337-3.84-4.492-5.28Z"
        />
        <path
          fill="#F4BAAF"
          d="M39.275 67.498c1.485 0 2.688-1.34 2.688-2.995 0-1.654-1.203-2.995-2.688-2.995-1.484 0-2.688 1.34-2.688 2.995 0 1.654 1.204 2.995 2.688 2.995Z"
        />
        <path
          fill="#582917"
          d="M45.56 65.3a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05ZM46.629 62.46l-3.008.96a.307.307 0 0 1-.384-.198l-.058-.192a.307.307 0 0 1 .198-.384l3.008-.96a.307.307 0 0 1 .384.199l.058.192a.307.307 0 0 1-.198.384ZM51.966 64.775a.527.527 0 0 1-.525.525.527.527 0 0 1-.524-.525c0-.288.236-.525.524-.525.288 0 .525.237.525.525ZM50.488 62.375l3.008.96a.307.307 0 0 0 .384-.199l.058-.192a.307.307 0 0 0-.199-.384l-3.008-.96a.307.307 0 0 0-.384.199l-.057.192a.307.307 0 0 0 .198.384Z"
        />
        <path
          fill="#CD8071"
          d="m48.805 67.922-1.684-.883a.277.277 0 0 1-.102-.403l1.869-2.855-.077 4.141h-.006Z"
        />
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={0.429}
          d="M40.715 68.899c-.166.813-.678 1.408-1.286 1.408-.743 0-1.338-.883-1.338-1.978 0-1.094.602-1.977 1.338-1.977"
        />
        <path
          fill="#F4BAAF"
          d="M61.662 64.503c0 1.658-1.203 2.995-2.688 2.995-1.484 0-2.688-1.344-2.688-2.995s1.204-2.995 2.688-2.995c1.485 0 2.688 1.344 2.688 2.995Z"
        />
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={0.429}
          d="M57.528 68.899c.166.813.678 1.408 1.286 1.408.743 0 1.338-.883 1.338-1.978 0-1.094-.602-1.977-1.338-1.977"
        />
        <path
          stroke="#B86B3E"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={0.25}
          d="M46.533 72.57s1.561.423 2.867.09"
        />
        <path
          fill="#F4BAAF"
          d="M53.265 70.016h-6.988l.275 6.419c.013.8 1.446 1.453 3.219 1.453s3.213-.647 3.22-1.453l.274-6.42Z"
        />
        <path
          stroke="#CD8071"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={0.429}
          d="M46.635 72.54s1.197.421 2.88.223"
        />
        <path
          stroke="#582917"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={0.429}
          d="M48.081 69.663s1.159.39 1.76-.749"
        />
        <path
          stroke="#582917"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={0.218}
          d="M48.081 69.663s1.159.39 1.76-.749"
        />
      </g>
      <path
        fill="#AF6E37"
        d="M38.7 50.308c0 .78-.42 1.53-1.3 1.85-3.98 1.48-4.54 2.22-7.22 1.84-.99-.14-2.31-.2-3.71-.31 1.21-2.46 2.88-4.64 4.92-6.43.36.12.73.21 1.11.19 1.29-.05 3.1 0 4.52.49.3.11.57.26.8.46 0 0 .94.92.88 1.91Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 7h127.05v113.17H0z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M47.11 92.188h15.04v23.867H47.11z" />
      </clipPath>
      <clipPath id="c">
        <path fill="#fff" d="M30.68 48.188h37.21v29.695H30.68z" />
      </clipPath>
    </defs>
  </svg>
);

export default IconVerifyBoostSVG;
